import { render, staticRenderFns } from "./render-copy.vue?vue&type=template&id=14140089&"
import script from "./render-copy.vue?vue&type=script&lang=js&"
export * from "./render-copy.vue?vue&type=script&lang=js&"
import style0 from "./render-copy.vue?vue&type=style&index=0&id=14140089&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports